export const searchApplicationDocument = `
    query searchApplicationDocument($emplid: String!, $programId: String!) {
        searchApplicationDocument(emplid: $emplid, programId: $programId) {
            data {
                customQuery
                displayColumns
                documentDate
                documentID
                fromID
                endDate
                documentTypes
                documentTypeGroup
                documentType
                documentName
                keywords {
                    keywordName
                    keywordOperator
                    keywordRelation
                    keywordValue
                }
                noteType
                rawDocumentDataProvider
                returnRawDocumentData
                sorts {
                    sortAscending
                    sortField
                    sortType
                }
                startDate
                textSearchConstraints
                toID
            }
        }
}`;

export const fetchDocumentUrl = `
 query fetchDocumentUrl($documentId: String!, $documentName: String) {
    fetchDocumentUrl(documentId: $documentId, documentName: $documentName) {
    data {
      uuid
      status
      url
      receiptId
    }
  }
}`

export const getApplicationDetails = `
    query getApplicationDetails($applicantEmployeeId: String!, $programId: String!, $term: String!) {
        getApplicationDetails(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term) {
            details {
                appBar {
                    applicantEmployeeId
                    campusId
                    firstName
                    is3rdReviewer
                    lastName
                    programId
                    programName
                    priority
                    dateOfBirth
                }
                    
                history {
                    reviewNumber
                    assignTime
                    submitTime
                    name
                    isNotifying
                    isAdminRecommendation
                    recommendation
                    reviewType
                    recommendationReason
                    administrativeNotes
                    rubricValues
                }

                demographics {
                    academicPlan
                    academicPlanDescription
                    academicProgram
                    academicProgramDescription
                    admitType
                    countryOfCitizenship
                    earlyAction
                    firstGen
                    homeCountry
                    lowSocioeconomic
                    regularDecision
                    residency
                    rural
                    stage
                    term
                    termLabel
                }
                    
                administratorDetails

                highSchool {
                    highSchoolName
                    highSchoolLocation
                    highSchoolGraduationDate
                    ceebCode
                    highSchoolGPA
                    classStandingSize
                    classRankPercentileType
                    bestTest {
                        comments
                        score
                    }
                }
                
                collegePrepUnits {
                    differenceForeignLanguage
                    differenceMath
                    differenceNaturalScience
                    earnedForeignLanguage
                    earnedMath
                    earnedNaturalScience
                    minimumForeignLanguage
                    minimumMath
                    minimumNaturalScience
                }

                testScores {
                    scores {
                        act {
                            composite
                            date
                            english
                            math
                            reading
                            science
                        }
                        sat {
                            date
                            evidenceBased
                            mathSection
                            readingTest
                            total
                        }
                    }
                    bestTest {
                        comments
                        score
                    }
                }
                    
                resumeLaterRubricValues
                
                resumeLaterAdminNotes {
                    label
                    section
                }
            }

            status {
                assignable
                currentRecommendation
                decision
                priority
                isApplicationReviewed
                isApplicationFinalized
                isApplicationCancelled
                canAdminOverride
                isAssignedReviewer
                isSubmittedReviewer
                reviewRecommendation
            }

            configuration {
                rubric
                administrativeNotes
                recommendationOptions
                adminOverrideOptions
                adminOverrideReasons
                assignableReviewers {
                    id
                    name
                }
                unassignableReviewers {
                    id
                    name
                }
            }
        }
    }
`;

export const applicationRestartReview = `
    mutation applicationRestartReview($applicantEmployeeId: String!, $programId: String!, $term: String!) {
        applicationRestartReview(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term) {
            status
        }
    }
`;

export const applicationReassignReview = `
    mutation applicationReassignReview($applicantEmployeeId: String!, $programId: String!, $term: String!, $reviewerEmployeeIdFrom: String!, $reviewerEmployeeIdTo: String!, $completedByDueDate: String!) {
        applicationReassignReview(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term, reviewerEmployeeIdFrom: $reviewerEmployeeIdFrom, reviewerEmployeeIdTo: $reviewerEmployeeIdTo, completedByDueDate: $completedByDueDate) {
            status
        }
    }
`;

export const applicationAssignReview = `
    mutation applicationAssignReview($applicantEmployeeId: String!, $programId: String!, $term: String!, $reviewerEmployeeIdTo: String!, $completedByDueDate: String!, $manuallyAssigned: Boolean) {
        applicationAssignReview(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term, reviewerEmployeeIdTo: $reviewerEmployeeIdTo, completedByDueDate: $completedByDueDate, manuallyAssigned: $manuallyAssigned) {
            status
        }
    }
`;

export const applicationUnassignReview = `
    mutation applicationUnassignReview($applicantEmployeeId: String!, $programId: String!, $term: String!, $reviewerEmployeeIdFrom: String!) {
        applicationUnassignReview(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term, reviewerEmployeeIdFrom: $reviewerEmployeeIdFrom) {
            status
        }
    }
`;

export const applicationConflictOfInterest = `
    mutation applicationConflictOfInterest($applicantEmployeeId: String!, $programId: String!, $term: String!) {
        applicationConflictOfInterest(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term) {
            status
        }
    }
`;

export const applicationSubmitReview = `
    mutation applicationSubmitReview($applicantEmployeeId: String!, $programId: String!, $term: String!, $resumeLater: Boolean!, $administrativeNotes: [AdministrativeNoteInput]!, $rubricValues: AWSJSON, $recommendation: String!) {
        applicationSubmitReview(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term, resumeLater: $resumeLater, administrativeNotes: $administrativeNotes, rubricValues: $rubricValues, recommendation: $recommendation) {
            status
        }
    }
`;

export const applicationSaveReview = `
    mutation applicationSaveReview($applicantEmployeeId: String!, $programId: String!, $term: String!, $resumeLater: Boolean!, $administrativeNotes: [AdministrativeNoteInput]!, $rubricValues: AWSJSON) {
        applicationSaveReview(applicantEmployeeId: $applicantEmployeeId, programId: $programId, term: $term, resumeLater: $resumeLater, administrativeNotes: $administrativeNotes, rubricValues: $rubricValues) {
            status
        }
    }
`;

export const adminOverride = `
    mutation adminOverride($applicantEmployeeIds: [String!], $programId: String!, $term: String!, $recommendation: String!, $overrideReason: String!) {
        adminOverride(applicantEmployeeIds: $applicantEmployeeIds, programId: $programId, term: $term, recommendation: $recommendation, overrideReason: $overrideReason) {
            status
            type
        }
    }
`;


export const getDocumentStatus = `
 query getDocumentStatus($uuid: String!) {
    getDocumentStatus(uuid: $uuid) {
    data {
      uuid
      status
      url
    }
  }
}`
